import { Component, OnInit } from '@angular/core';
import {LeaderboardService} from "../../services/leaderboard.service";
import { Location } from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {AuthService} from "../../services/auth.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.css']
})
export class LeaderboardComponent implements OnInit {
  userAccounts: any[] = [];
  useersLoaded: boolean = false;
  referralCodeData:any;
  baseUrl:any;
  userDetails:any;
  pageNo = 1;
  pageSize = 10;
  totalRecords: any = 0;
  pages:any=0;
  constructor(private _leaderboardService:LeaderboardService,private location: Location,private _authService:AuthService) { }
  ngOnInit(): void {
      this._authService.user.subscribe(user => {
          this.userDetails = user;
      })
      this.userDetails=this._authService.userValue;
    this.fetchUserAccounts(this.pageNo);
  }
  fetchUserAccounts(page:any): void {
    this._leaderboardService.getAllUserAccounts(page,this.pageSize).subscribe(
        (data: any) => {
          this.userAccounts = data.userAccountsDto || data.userAccountDtoList || [];
          this.useersLoaded = true;
          this.totalRecords = data.pagination.totalObjects;
          this.baseUrl = window.location.origin;
          this.pageNo = page;
          this.pages =data.pagination.pages;
        },
        (error) => {
          console.error('Error fetching userAccounts:', error);
        }
    );
  }

    generateReferralCode() {
        this._leaderboardService.getReferralCode(this.userDetails.username).subscribe(
            (data: any) => {
                this.referralCodeData = data;
            }
        );
    }
    copyReferralLink() {
        const referralInput: HTMLInputElement = document.getElementById('referralInput') as HTMLInputElement;
        if (!referralInput) {
            return;
        }
        const link = referralInput.value;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link).then(() => {
                Swal.fire('Copied', 'Referral link copied to clipboard.', 'success');
            });
            return;
        }
        referralInput.select();
        document.execCommand('copy');
        Swal.fire('Copied', 'Referral link copied to clipboard.', 'success');
    }

    isCurrentUser(userAccount: any): boolean {
      if (!this.userDetails || !userAccount?.user) {
        return false;
      }
      const currentUsername = this.userDetails.username || this.userDetails.userName;
      const accountUsername = userAccount.user.userName || userAccount.user.username;
      const currentId = this.userDetails.id;
      const accountId = userAccount.user.id;
      return (currentUsername && accountUsername && currentUsername === accountUsername)
        || (currentId && accountId && currentId === accountId);
    }
}
